import React, { ReactElement } from 'react';
import { Typography, makeStyles, Container } from '@material-ui/core';
import londonBanner from './londonBanner.png';
import { Fade } from 'react-awesome-reveal';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles({
    title: {
        margin: '2rem 0 4rem 0',
    },
    secondBanner: {
        padding: '20rem 0',
        backgroundImage: `url("${londonBanner}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    },
    textBody: {
        marginBottom: '3rem',
    },
});

function ServicePage(): ReactElement {
    const classes = useStyles();

    return (
        <div>
            <Container maxWidth="md">
                <Helmet>
                    <title>London Insulation Services | Services</title>
                </Helmet>
                <Fade>
                    <Typography align="center" className={classes.title} variant="h4">
                        Our Services
                    </Typography>
                    <Typography className={classes.textBody} variant="h6">
                        We offer a whole range of insulation services, including:
                    </Typography>
                    <Typography color="textPrimary" className={classes.textBody} variant="h6">
                        - Thermal insulation to pipework
                        <br />
                        - Thermal insulation to ductwork 
                        <br />
                        - Acoustic insulation-sound proofing 
                        <br />
                        - Fire rated ductwork insulation 
                        <br />
                        - Fire stopping 
                        <br />
                        - Trace Heating 
                        <br />
                        - Frost protection 
                        <br />
                        - Constant temperature 
                        <br />
                        - Sheet Metal Fabrication 
                        <br />
                        - Removable Valve bags/matts 
                        <br />- Supply of materials only
                    </Typography>
                    <Typography color="textPrimary" className={classes.textBody} variant="h6">
                        Should any of the services listed be of interest please do not hesitate in contacting us. We’d
                        welcome the opportunity to meet face to face in our London Head Quarters.
                    </Typography>
                </Fade>
            </Container>
            <div className={classes.secondBanner}></div>
        </div>
    );
}

export default ServicePage;
